import React from "react";
/* empty css          */
import { Icon as Icon$1 } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import "@mui/material/colors";
import "@mui/material/locale";
import "@mui/material/styles";
import { useSystemColors } from "../../style/hooks.js";
var IconColor = /* @__PURE__ */ ((IconColor2) => {
  IconColor2["Success"] = "Success";
  IconColor2["InProgress"] = "InProgress";
  IconColor2["Primary"] = "Primary";
  IconColor2["Secondary"] = "Secondary";
  IconColor2["PrimaryContrastText"] = "PrimaryContrastText";
  IconColor2["Warning"] = "Warning";
  IconColor2["Bronze"] = "Bronze";
  IconColor2["SuitRed"] = "SuitRed";
  IconColor2["SuitBlack"] = "SuitBlack";
  return IconColor2;
})(IconColor || {});
const useIconStyles = makeStyles()((theme) => {
  return {
    icon: {
      fontSize: "1em"
    },
    success: {
      color: theme.custom.palette.content.secondarySuccess
    },
    warning: {
      color: theme.palette.warning.main
    },
    inProgress: {
      color: theme.custom.palette.content.secondaryInProgress
    },
    primary: {
      color: theme.palette.primary.main
    },
    secondary: {
      color: theme.palette.secondary.main
    },
    bronze: {
      color: theme.custom.palette.status.bronze.main
    },
    primaryContrastText: {
      color: theme.palette.primary.contrastText
    },
    suitRed: {
      color: theme.custom.palette.content.suitRed
    },
    suitBlack: {
      color: theme.custom.palette.content.suitBlack
    },
    fontSizeSmall: {
      fontSize: `${theme.typography.h6.fontSize} !important`
    }
  };
});
function useIconColorClasses() {
  const systemColors = useSystemColors();
  const { classes } = useIconStyles();
  const iconColors = {
    [
      "Success"
      /* Success */
    ]: classes.success,
    [
      "InProgress"
      /* InProgress */
    ]: classes.inProgress,
    [
      "Primary"
      /* Primary */
    ]: classes.primary,
    [
      "Secondary"
      /* Secondary */
    ]: classes.secondary,
    [
      "PrimaryContrastText"
      /* PrimaryContrastText */
    ]: classes.primaryContrastText,
    [
      "Warning"
      /* Warning */
    ]: classes.warning,
    [
      "Bronze"
      /* Bronze */
    ]: classes.bronze,
    [
      "SuitRed"
      /* SuitRed */
    ]: classes.suitRed,
    [
      "SuitBlack"
      /* SuitBlack */
    ]: classes.suitBlack,
    ...systemColors
  };
  return iconColors;
}
const Icon = ({ icon, className, color, ...otherProps }) => {
  const { classes, cx } = useIconStyles();
  const colorClasses = useIconColorClasses();
  const colorClass = color ? colorClasses[color] : null;
  return /* @__PURE__ */ React.createElement(
    Icon$1,
    {
      classes: { fontSizeSmall: classes.fontSizeSmall },
      className: cx(classes.icon, icon, colorClass, className),
      ...otherProps
    }
  );
};
export {
  Icon,
  IconColor,
  useIconColorClasses
};
//# sourceMappingURL=Icon.js.map
